// Aluno 360 · resumo da documentação. O controle completo vive na Central de Documentação.
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { FolderCheck, ShieldCheck, CircleDashed, FileClock } from 'lucide-react';
import api from '@/lib/api';

const TONE = {
  completa: { icon: ShieldCheck, cls: 'bg-emerald-50 text-emerald-700 border-emerald-200' },
  parcial: { icon: FileClock, cls: 'bg-amber-50 text-amber-800 border-amber-200' },
  nao_solicitada: { icon: CircleDashed, cls: 'bg-slate-50 text-slate-600 border-slate-200' },
};

export default function DocumentacaoResumo({ studentId }) {
  const nav = useNavigate();
  const [s, setS] = useState(null);
  useEffect(() => {
    if (!studentId) return;
    api.get(`/document-center/students/${studentId}/summary`).then(({ data }) => setS(data)).catch(() => setS(null));
  }, [studentId]);
  if (!s) return null;
  const t = TONE[s.state] || TONE.nao_solicitada;
  const Icon = t.icon;
  return (
    <div className={`mb-3 flex flex-wrap items-center gap-3 rounded-xl border p-3 ${t.cls}`} data-testid="doc-resumo">
      <Icon className="h-5 w-5 shrink-0" />
      <div className="min-w-0 flex-1">
        <p className="text-[13px] font-bold" data-testid="doc-resumo-state">Documentação: {s.label}</p>
        {s.state !== 'nao_solicitada' ? (
          <p className="text-[11.5px] opacity-80" data-testid="doc-resumo-detail">
            {s.academic_year} · obrigatórios {s.required_received}/{s.required_total} · depois {s.later_received}/{s.later_total} · {s.status_label}
          </p>
        ) : <p className="text-[11.5px] opacity-80">Aluno sem solicitação de documentos — não aparece como pendente.</p>}
      </div>
      <Button size="sm" className="h-8 rounded-lg bg-[#7B3F98] hover:bg-[#5E2F7A]" data-testid="btn-abrir-documentacao"
        onClick={() => nav(s.state === 'nao_solicitada' ? `/v2/matriculas/documentos?request=${studentId}`
          : `/v2/matriculas/documentos?student=${studentId}&year=${s.academic_year}`)}>
        <FolderCheck className="mr-1.5 h-4 w-4" /> {s.state === 'nao_solicitada' ? 'Solicitar documentação' : 'Abrir documentação'}
      </Button>
    </div>
  );
}
